import React, { useEffect, useState } from 'react'

// import { playerScaleSelector } from 'lib/state/selectors'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { VideoHelper } from 'secondstepVideo'

import VideoComponent from './component'
import { GET_CAPTION_TRACK_OBJECT, ShowMenuBarForEnglish } from './data'
import { onVideoEnded, onVideoPlay, onVideoStopped } from './helpers'

const VideoContainer = ({ videoReference, vtts }) => {
  const [transcript, setTranscript] = useState(null)
  const [audioDescriptionTranscript, setAudioDescriptionTranscript] = useState(
    null,
  )

  const [isTranscriptActive, setIsTranscriptActive] = useState(false)
  const [isAudioDescActive, setIsAudioDescActive] = useState(false)
  const [transcriptRendered, setRenderTranscript] = useState(false)
  const [isFetchingTranscript, setIsTranscriptFetching] = useState(false)
  // EA = "Extended Audio"
  const [isFetchingEATranscript, setIsFetchingEATranscript] = useState(false)

  const dispatch = useDispatch()

  const { fields } = videoReference || {}
  const { bitmovinUrl, bitmovinUrlExtended } = fields || {}
  const hasVideo = VideoHelper.hasVideoBitmovinSource(videoReference)
  const settings = VideoHelper.getSettings({
    addPlayBackSpeedControls: true,
  })
  const poster = VideoHelper.getVideoModulePosterSource(videoReference)
  const transcriptSrc = VideoHelper.getVideoModuleTranscriptSource(
    videoReference,
  )
  const extendedAudioTranscriptSrc = VideoHelper.getVideoModuleExtendedAudioTranscriptSource(
    videoReference,
  )

  const tracks = GET_CAPTION_TRACK_OBJECT(videoReference)

  const vttPauseSource = VideoHelper.getVideoModuleVttPauseSource(
    videoReference,
  )
  const vttExtendedPauseSource = VideoHelper.getVideoModuleVttPauseExtendedSource(
    videoReference,
  )

  if (vttPauseSource || vttExtendedPauseSource) {
    settings.plugins = VideoHelper.getExtendedSetting(
      isAudioDescActive ? vttExtendedPauseSource : vttPauseSource,
    )
  }

  const handleLoad = async () => {
    setIsTranscriptFetching(true)
    const r = await fetch(transcriptSrc)
    if (!r.ok) {
      return
    }
    const text = await r.text()
    setTranscript(text)
    setIsTranscriptFetching(false)
  }

  const handleExtendedAudioTranscriptLoad = async () => {
    setIsFetchingEATranscript(true)
    const r = await fetch(extendedAudioTranscriptSrc)
    if (!r.ok) {
      return
    }
    const text = await r.text()
    setAudioDescriptionTranscript(text)
    setIsFetchingEATranscript(false)
  }

  const handleTranscriptActiveStatus = () => {
    setIsTranscriptActive(true)
  }

  const handleVideoPlay = () => {
    onVideoPlay(dispatch)
  }

  const handleVideoStop = () => {
    onVideoStopped(dispatch)
  }

  const handleVideoEnd = () => {
    onVideoEnded(dispatch)
  }

  const shouldWaitForTranscript =
    transcriptSrc && isFetchingTranscript && !transcript
  const shoulWaitForEATranscript =
    extendedAudioTranscriptSrc &&
    isFetchingEATranscript &&
    !audioDescriptionTranscript

  useEffect(() => {
    if (!transcript && transcriptSrc && !isFetchingTranscript) {
      handleLoad()
    }
  })

  useEffect(() => {
    if (
      extendedAudioTranscriptSrc &&
      !audioDescriptionTranscript &&
      !isFetchingEATranscript
    ) {
      handleExtendedAudioTranscriptLoad()
    }
  })

  const showTranscript = () => {
    if (!transcriptRendered && transcriptSrc) {
      setRenderTranscript(true)
      setIsTranscriptActive(true)
    }
    if (transcriptRendered) {
      setRenderTranscript(false)
      setIsTranscriptActive(false)
    }
  }
  const menuBarRenderedForEnglish = ShowMenuBarForEnglish()
  const handleClickAudioDesc = () => setIsAudioDescActive(!isAudioDescActive)
  const canShowAudioDescriptionButton = bitmovinUrlExtended !== undefined
  const canShowTranscriptButton = transcriptSrc !== undefined
  const canShowAccessibilityMenu =
    canShowAudioDescriptionButton === true || canShowTranscriptButton === true

  if (!bitmovinUrl || shouldWaitForTranscript || shoulWaitForEATranscript) {
    return null
  }

  const videoUrl = isAudioDescActive ? bitmovinUrlExtended : bitmovinUrl

  return (
    <VideoComponent
      accessibilityUrl={bitmovinUrlExtended}
      audioDescriptionTranscript={audioDescriptionTranscript}
      canShowAccessibilityMenu={canShowAccessibilityMenu}
      canShowAudioDesc={canShowAudioDescriptionButton}
      canShowAudioDescriptionButton={canShowAudioDescriptionButton}
      canShowTranscriptButton={canShowTranscriptButton}
      handleTranscriptActiveStatus={handleTranscriptActiveStatus}
      handleClickAudioDesc={handleClickAudioDesc}
      hasVideoSource={hasVideo}
      isTranscriptActive={isTranscriptActive}
      isAudioDescActive={isAudioDescActive}
      key={videoUrl}
      menuBarRenderedForEnglish={menuBarRenderedForEnglish}
      onEnded={handleVideoEnd}
      onPlay={handleVideoPlay}
      onStopped={handleVideoStop}
      poster={poster}
      settings={settings}
      showTranscript={showTranscript}
      tracks={tracks}
      transcript={transcript}
      transcriptRendered={transcriptRendered}
      videoUrl={videoUrl}
      vtts={vtts}
    />
  )
}

VideoContainer.propTypes = {
  videoReference: PropTypes.object,
  vtts: PropTypes.object,
  scale: PropTypes.number,
}

VideoContainer.defaultProps = {
  scale: 1,
}

export default VideoContainer
